import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height", "viewBox"];
const _hoisted_2 = ["stroke"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: $props.width,
    height: $props.height,
    viewBox: `0 0 ${$props.width} ${$props.height}`,
    fill: "none"
  }, [_createElementVNode("path", {
    d: "M9.5 5V2M8 3.5H11M8 10.5V9.9C8 9.05992 8 8.63988 7.83651 8.31901C7.6927 8.03677 7.46323 7.8073 7.18099 7.66349C6.86012 7.5 6.44008 7.5 5.6 7.5H3.4C2.55992 7.5 2.13988 7.5 1.81901 7.66349C1.53677 7.8073 1.3073 8.03677 1.16349 8.31901C1 8.63988 1 9.05992 1 9.9V10.5M6.25 3.75C6.25 4.7165 5.4665 5.5 4.5 5.5C3.5335 5.5 2.75 4.7165 2.75 3.75C2.75 2.7835 3.5335 2 4.5 2C5.4665 2 6.25 2.7835 6.25 3.75Z",
    stroke: $props.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null, 8, _hoisted_2)], 8, _hoisted_1);
}